const icon = {
  position: 'absolute',
  fontSize: '1.4rem',
  borderRadius: '50%',
  color: 'white',
  width: '2.5rem',
  height: '2.5rem',
  display: 'flex',
  '&:not(.skipCursor)': { cursor: 'pointer' }
}

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: 'black',
    width: '100%'
  },
  header: {
    display: 'flex',
    width: '100%',
    '& span': { flex: '1 1 auto' }
  },
  disconnect: {
    color: '#fd9999',
    '&:hover': { color: 'red' },
    '& svg': { marginRight: '.25rem' }
  },
  mobileDisconnect: {
    color: 'red',
    '&:hover': { color: '#E60000' },
    '& svg': { marginRight: '.25rem' }
  },
  cameraLabel: {
    paddingLeft: '1rem'
  },
  canvasWrapper: {
    margin: '1rem auto',
    width: 300,
    height: 50,
    position: 'relative',
    display: 'flex'
  },
  mobileCanvasWrapper: {
    margin: '1rem auto',
    width: '80%',
    height: '13vw',
    position: 'relative',
    display: 'flex'
  },
  canvas: {
    width: '100%',
    height: '100%'
  },
  cameraIcon: {
    position: 'absolute',
    width: 14,
    height: 'auto',
    top: '5px',
    left: '-3px',
    transformOrigin: 'center top',
    transform: 'rotateZ(90deg)',
    '&:not(.skipCursor)': { cursor: 'pointer' }
  },
  otherIcon: {
    ...icon,
    top: '-.75rem',
    left: '-2.5rem'
  },
  endIcon: {
    ...icon,
    bottom: '-7px',
    right: '-.8rem'
  },
  networkClosetIcon: {
    position: 'absolute',
    bottom: '-6px',
    right: '-.9rem',
    fontSize: '2.2rem',
    cursor: 'pointer'
  },
  endDeviceLabel: {
    paddingRight: '1rem',
    width: '100%',
    minHeight: '2.6rem',
    display: 'flex',
    alignItems: 'center'
  },
  distanceText: {
    flex: '1 0 auto',
    marginRight: '2rem'
  },
  distanceTextFadeIn: {
    visibility: 'visible',
    opacity: 1,
    transition: 'visibility 0s linear 0s, opacity 200ms linear'
  },
  distanceTextFadeOut: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 0s linear 200ms, opacity 200ms linear'
  }
}



// WEBPACK FOOTER //
// ./src/components/WireDetails/Diagram/style.js